/**
 * TODO[ATLAS]:
 * Remove this file once we can get parseUAString exported from the ClientSDK
 * (libs/shared/utils/src/browser/ua.ts)
 */

import { UAParser } from 'ua-parser-js';

export function getDeviceInfo(): IDeviceInfo {
    return {
        ...parseUAString(document?.defaultView?.navigator?.userAgent),
        devicePlatform: 'web-desktop',
        version: '1.0',
        appName: 'web',
    } as IDeviceInfo;
}

type RegistrableDevicePlatform =
    | 'android'
    | 'android-tv'
    | 'apple-phone'
    | 'apple-tablet'
    | 'apple-tv'
    | 'fire-tablet'
    | 'fire-tv'
    | 'google-cast'
    | 'roku'
    | 'samsung-tv'
    | 'sony-tv'
    | 'web-desktop'
    | 'web-mobile';
export interface IDeviceInfo {
    deviceOs?: string;
    name?: string;
    version: string;
    engineVersion?: string;
    deviceModel?: string;
    appName?: 'web';
    appRegion: 'US' | 'CA';
    userAgent: string;
    deviceOsVersion?: string;
    vendor?: string;
    devicePlatform: RegistrableDevicePlatform;
}

export function parseUAString(userAgent = '', host = '') {
    const uaParser = new UAParser();
    uaParser.setUA(userAgent);

    const result: UAParser.IResult = uaParser.getResult();
    const urlArr = host.split('.');
    const appRegion = urlArr[urlArr.length - 1];
    return {
        deviceOs: result.os.name,
        deviceOsVersion: result.os.version,
        name: result.browser.name,
        version: result.browser.version,
        deviceModel: result.device.model,
        appRegion: appRegion.toUpperCase() === 'CA' ? 'CA' : 'US',
        userAgent: uaParser.getUA(),
        vendor: result.device.vendor,
    };
}
